export default "__VITE_ASSET__DwdOY4ON__"